import React from "react";

const OtherBenefit = () => {
  return (
    <div
      className="pb-5 z-index-2 mt-n1 bg-white"
      style={{ position: "sticky" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="mb-1 font-weight-bolder">Other Benefits</h4>
            <h5>Post-training mentorship and alumni networking</h5>
            <p className="mb-0">
              Mentorship of alumni by seasoned mentors will be encouraged and supported where participants, after completion of the training program, may undertake projects such as reviews of their national malaria SM&E plans or evaluation of malaria surveillance systems, etc., with the experiences from such collaborative works further strengthening the program and skills of the participants. Social media forums and discussion blogs will be developed from the alumni databases of the more than 300 trained health personnel in fundamentals of M&E, surveillance, and advanced evaluation methods.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherBenefit;
